import { useState, useEffect, useCallback } from 'react';
import { Platform, NativeSyntheticEvent, NativeScrollEvent } from 'react-native';

export function useScrolled(threshold = 0) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const handler = () => setScrolled(window.scrollY > threshold);

    window.addEventListener('scroll', handler, { passive: true });
    handler();

    return () => window.removeEventListener('scroll', handler);
  }, [threshold]);

  const onScroll = useCallback(
    (e: NativeSyntheticEvent<NativeScrollEvent>) => {
      if (Platform.OS === 'web') return;

      setScrolled(e.nativeEvent.contentOffset.y > threshold);
    },
    [threshold],
  );

  return { scrolled, onScroll };
}
